import auth from '../services/auth'

/**
 * =================================================================
 * Auth routes
 * =================================================================
 *
 * Lazy loads component to initial page load improve performance.
 * Components are only loaded when a user is entering the route.
 * Access to this routes is for guests only.
 *
 * =================================================================
 */
const AuthLogin = () => import('../components/AuthLogin')

export default {
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: AuthLogin,
      beforeEnter: (to, from, next) => redirectUserIfAuthenticated(from, next)
    }
  ]
}

/**
 * Only guests are allowed to enter the route.
 *
 * @param from
 * @param next
 */
async function redirectUserIfAuthenticated (from, next) {
  const access = auth.getAuth()

  if (!access) return next()

  const verified = await auth.verifyAccessToken()
    .then(({ data }) => {
      auth.setUser(data)
      return data
    })
    .catch(() => auth.flush())

  return verified && next(from.path)
}
